// @core/api/endpoints/bootstrap/save_admin_account.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  SaveAdminAccountRequest,
  SaveAdminAccountResponse,
} from '../../../types/bootstrap';

const BASE_PATH = '/bootstrap';

/**
 * Save admin account
 * Saves the initial administrator account details. Password is validated for complexity but NOT persisted in plaintext — only held in memory until execution.
 * @public This endpoint does not require authentication
 */
export async function SaveAdminAccount(
  data: SaveAdminAccountRequest,
  options?: RequestOptions
): Promise<SaveAdminAccountResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/setup/steps/admin`;
  const requestOptions = { ...options, skipAuth: true };
  return client.put<SaveAdminAccountResponse>(requestPath, data, requestOptions);
}
